import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Paper, Typography } from '@/core/ui';
import { Link } from 'react-router-dom';
// TODO: (styling) https://tailwindui.com/components/preview
const NotFound = () => {
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h1", sx: { opacity: 0 }, children: "Page not found." }), _jsx(Paper, { sx: { p: 4 }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '600px',
                        gap: 5,
                    }, children: [_jsx(Box, { children: _jsx(Typography, { variant: "h3", children: "This page doesn't exist." }) }), _jsx(Box, { children: _jsxs(Typography, { variant: "h3", children: ["Go to ", _jsx(Link, { to: "/", children: "Home" })] }) })] }) })] }));
};
export { NotFound };
